import Vue from 'vue'
import Vuex, { Store } from 'vuex'
import router from '@/router'
//import Aplicacion from '@/controlador/aplicacion'

Vue.use(Vuex)

export default

new Vuex.Store({

    state:{

        //# Versión #//
        version_frontend: '[ Estable 6.0.0.8.8 ] - [ 14:41 :: 22-05-2023 NZC ]',
        version_backend: '',
        version_list: [],

        //# Generales #//
        administradores: ['leocjnz@gmail.com','nzcaicedo@gmail.com','yesid.anacona@axongroup.com.co','yesid8@gmail.com'],
        url_api: process.env.VUE_APP_BASE_URL ? process.env.VUE_APP_BASE_URL : 'http://localhost:8000/api/',
        urlsb: process.env.VUE_APP_BASE_URLBA ? process.env.VUE_APP_BASE_URLBA : 'http://localhost:8000/',
        urlsf: process.env.VUE_APP_BASE_URLF ? process.env.VUE_APP_BASE_URLF : 'http://localhost:8080/',
        loading: false,
        fullpagina:true,
        miniloading: false,
        types_persona:[{name:'Coordinador',type:'coordinador'},{name:'Ingeniero',type:'ingeniero'},{name:'Cliente',type:'cliente'},{name:'Gestor',type:'gestor'},{name:'Colaborador',type:'colaborador'}],
        notificacion_local:{'run':false,'tipo':'','titulo':'','contenido':'','errores':[],'tiempo':0,'cerrar':false},
        notificacion_global:{'run':false,'titulo':'','contenido':'','icono':''},
        seccion_num: 50, // seccion de vista por defecto en dashboard // 50-areas de trabajo
        seccion_head: 1, // seccion de encabezado por defecto en menu de accesos directos // 1-home 2-forecast 3-innova 4-proyecto 5-crear 6-perfil
        
        //#datos del usuario#//
        user: {'id':0,'email':''}, // usuario logueado
        user_data:{'t_ideas':0,'t_retos':0,'t_puntos':0,'redimidos':0},

        puntos_user_value: {'puntos':0,'redimidos':0}, // valor de puntos y redimidos por usuario en workarea
        actual_rol:'admin', //rol actual
        token:'', //token de sesión
        login:false, // estado de login
        active_users: [], // usuarios activos

        //# proyectos #//
        proyectos: [],
        proyecto_actual: {'id':0,'text':'','creador_id':0},
        mensajes_pro: [],
        archivos_pro: [],
        folders_pro: [],
        asignadosp: [], // usuarios compartidos a un proyecto / 
        kanban: [],
        notificaciones: [], // notificaciones configuradas del proyecto
        unread_mensajes_pro: [],

        //# tareas #//

        todas: [],
        tareas: [],
        mastertarea: {'proyecto_id':0},
        compras: [],
        mastercompra: {'proyecto_id':0},
        booltarea: true, // booleano para actualizar gantt y otros relacionados con tareas
        asignados: [], // asignados a tareas
        tareas_horasp: [],
        tareas_mishoras: [],
        tareas_temp: [],
        temporaltarea: {'id':0},
        temporaltarea_chat: {'id':0},
        temporalcompra: {'id':0},
        temporalcompra_chat: {'id':0},
        temporalpersona: {},
        temporaltareagantt: {},

        //# horas #//
        user_horas: [],
        horas: [],
        horas_registro_proyecto: [],
        horas_mishoras: [],
        

        //## area de trabajo ##//
        work_areas: [], 
        workarea_actual: {'id':0,'email':''},
        personal: [], // personal en area de trabajo
        personal_horasp: [], // personal consulta horas x proyecto
        proveedores: [], // proveedores de area de trabajo

        proyecto_actual_mishoras: {'id':0,'creador_id':0,'codigo':'Select'},
        proyecto_actual_horas: {'id':0,'creador_id':0,'codigo':'Select'},

        tareasip: [], // tareas invitado url gantt
        comprasip: [], // compras invitado url gantt
        horasip: [], // registro horas url gantt
        proip: {}, // proyecto actual url gantt

        //# Roles #//
        coordinador: { proyectos:[], tareas:[], personal:[], compras:[], gantt:[], gantc:[], horas:[], balance:[], workarea:[],anothers:[] },
        ingeniero: { proyectos:[], tareas:[], personal:[], compras:[], gantt:[], gantc:[], horas:[], balance:[], workarea:[],anothers:[] },
        cliente: { proyectos:[], tareas:[], personal:[], compras:[], gantt:[], gantc:[], horas:[], balance:[], workarea:[],anothers:[] },
        gestor: { proyectos:[], tareas:[], personal:[], compras:[], gantt:[], gantc:[], horas:[], balance:[], workarea:[],anothers:[] },
        colaborador: { proyectos:[], tareas:[], personal:[], compras:[], gantt:[], gantc:[], horas:[], balance:[], workarea:[],anothers:[] },

        //# Configuración notifiaciones #//
        configuracion: { notificacion:[],general:[] },

        //# Recaptcha #//
        recapsitekey: process.env.VUE_APP_CAP_CLIENTKEY ? process.env.VUE_APP_CAP_CLIENTKEY:'6LcHaFkaAAAAAC0Sd_8OYHXquP1ADN6vnRoIBi8O',

        //# Google_gapi #//
        gapi_clientkey: process.env.VUE_APP_GAPI_CLIENTKEY ? process.env.VUE_APP_GAPI_CLIENTKEY:'263334032765-abrqa3o6h2nt0tb0rr65q7d6cnb6oc19.apps.googleusercontent.com',
        gapi_secretkey: process.env.VUE_APP_GAPI_SECRET ? process.env.VUE_APP_GAPI_SECRET:'zHM_K9qebvzw98_CenrBBtQ',
        
        //# pusher #//
        pushersitekey: process.env.VUE_APP_PUSH_CLIENTKEY ? process.env.VUE_APP_PUSH_CLIENTKEY:'2d5fcd0700b6013d9db4',
        pushercluster: process.env.VUE_APP_PUSH_CLUSTER ? process.env.VUE_APP_PUSH_CLUSTER:'us2',
        pusherchannelpro: process.env.VUE_APP_PUSH_CHANNEL_PRO ? process.env.VUE_APP_PUSH_CHANNEL_PRO:'proyecto-',
        pushersocket: 0,
        syncpusher_state: false, // estado de sincronización pusher

        timesheet_data: [], // dato residual vista recursos
        timesheet_data_pros: [], // dato residual vista recursos
        
        //# innova #//

        ideas: [], 
        idea_actual: {'id':0,'l_description':'ABC'},
        idea_actual_config:{'seccion':0}, //configuracion de vista
        idea_clicked:{'id':0},
        challenge_clicked:{'id':0},
        
        retos: [],
        reto_actual: {'id':0,'l_description':'ABC'},
        reto_actual_config:{'seccion':0}, //configuracion de vista
        
        ideas_reto:[], // ideas de un reto especifico
        idea_actual_reto:{'id':0,'l_description':'ABC'}, //idea seleccionada de un reto especifico

        blogs: [], // items en la vista blogs
        
        coms_ideas: [], // comentarios ideas
        coms_retos: [], // cpmentarios retos
        coms_blogs: [], // comentarios blogs

        categorias_retos: [{'id':0,'cat':0,'pred':1,'name':'Standard','recurso':'reto'}],
        categorias_ideas: [{'id':0,'cat':0,'pred':1,'name':'Standard','recurso':'idea'}],
        imagenes_default: [
                            '1','2','3','4','5','6','7','8', //imagenes por defecto para ideas y retos
                            '9','10','11','12','13','14',
                            '15','16','17','18','19','20',
                            '100','101','102','103','104',
                            '200','201','202','203','204',
                            '300','301','302','303','304',
                            '400','401','402','403','404',
                            '500','501','502','503','504',
                            '600','601','602','603','604',
                            '700','701','702','703','704',
                            '800','801','802','803','804',
                            '900','901','902','903','904'
                          ],

        //# puntosvalues #//

        puntos_value: {}, // valor de puntos en administrador
        puntos_user: {"crear_idea":0,"crear_reto":0,"comt_idea":0,"comt_reto":0,"like_idea":0,"like_reto":0,"mejora_idea":0,"mejora_reto":0,"ver_idea":0,"ver_reto":0,"star_idea":0,"star_reto":0,"total_puntos":0},
        
        //paginado
        paginado_ideas:{'paginas':0,'actual':0,'total_ideas':0},
        pagina_actual_ideas:0,
        paginado_ideas_retos:{'paginas':0,'actual':0,'total_ideas':0},
        pagina_actual_ideas_retos:0,
        paginado_retos:{'paginas':0,'actual':0,'total_ideas':0},
        pagina_actual_retos:0,

        //# Regalos #//

        regalos_workarea:[], // lista de regalos
        redimidos_workarea:[], // lista de regalos redimidos del workarea

        redimidos_lista:[], // lista de regalos redimidos del usuario

        //# Notificaciones / Eventos /#//
        notificaciones_eventos:[],
        notificaciones_contador:0

    },

    mutations: {

        set_login(state,boolean){ state.login=boolean},
        set_version_backend(state,string){ state.version_backend=string},
        set_version_list(state,array){ state.version_list=array},
        set_seccion_num(state,number){ state.seccion_num=number },
        set_seccion_head(state,number){ state.seccion_head=number },
        set_updatetask(state){ if(state.booltarea){ state.booltarea= false }else{ state.booltarea= true } },
        set_temppersona(state,json){ state.temporalpersona=json },
        set_temptarea(state,json){ state.temporaltarea=json },
        set_temptarea_chat(state,json){ state.temporaltarea_chat=json },
        set_temptareagantt(state,json){ state.temporaltareagantt=json },
        set_tempcompra(state,json){ state.temporalcompra=json },
        set_token(state,string){ state.token=string },

        set_workarea_actual(state,json){ state.workarea_actual = json},
        set_workareas(state,array){ state.work_areas = array},

        set_registro(state,json){
            state.token = json.token,
            state.login = true,
            state.user = json.user
        },

        set_loginindex_start(state,json){
            state.login = true,
            state.token = json.token,
            state.user = json.user,
            state.work_areas = json.areas
        },

        set_loading(state,boolean){ state.loading = boolean },
        set_miniloading(state,boolean){ state.miniloading = boolean },
        set_notificacion_local(state,json){ state.notificacion_local = json },
        set_notificacion_global(state,json){ state.notificacion_global= json },
        set_proyectos(state,array){ state.proyectos = array },
        set_master_tarea(state,array){ state.mastertarea=array[0] },
        set_master_compra(state,array){ state.mastercompra=array[0] },
        set_personal(state,array){ state.personal = array },
        set_proveedores(state,array) { state.proveedores = array },
        set_todas(state,array){ state.todas = array },
        set_tareas(state,array){ state.tareas = array },
        set_tareas_horasp(state,array){ state.tareas_horasp = array },
        set_tareas_mishoras(state,array){ state.tareas_mishoras = array },
        set_tareas_temp(state,array){ state.tareas_temp = array },
        set_compras(state,array){ state.compras = array },
        set_asignados(state,array){ state.asignados = array },
        set_asignadosp(state,i){ state.asignadosp = i },
        set_horas(state,array){ state.horas = array },
        set_horas_regisro_proyecto(state,array){ state.horas_registro_proyecto = array },
        set_horas_mishoras(state,array){ state.horas_mishoras = array },
        set_mensajes_pro(state,array){ state.mensajes_pro = array },
        set_archivos_pro(state,array){ state.archivos_pro = array },
        set_folders_pro(state,array){ state.folders_pro = array },
        set_unread_mensajes_pro(state,array){ state.unread_mensajes_pro = array },
        set_user_horas(state,array){ state.user_horas = array },

        set_proyecto_actual(state,json){ 

            this.dispatch('syncpusher',json.id) 
            state.proyecto_actual = json 

        },

        set_proyecto_actual_mishoras(state,json){ state.proyecto_actual_mishoras = json },
        set_proyecto_actual_horas(state,json){ state.proyecto_actual_horas = json },

        set_user(state,json){ state.user = json },
        set_tareasip(state,array){ state.tareasip = array },
        set_comprasip(state,array){ state.comprasip = array },
        set_horasip(state,array){ state.horasip = array },
        set_pro_ip(state,json){ state.proip = json },

        set_coordinador(state,json){ state.coordinador = json },
        set_ingeniero(state,json){ state.ingeniero = json },
        set_cliente(state,json){ state.cliente = json },
        set_gestor(state,json){ state.gestor = json },
        set_colaborador(state,json){ state.colaborador = json },
        set_actual_rol(state,json){ state.actual_rol = json },
        suscripcion_pusher(state,boolean){state.syncpusher_state = boolean },
        set_socket_pusher(state,number){state.pushersocket = number },
        set_configuracion(state,json){ state.configuracion = json },
        set_notificaciones(state,array){ state.notificaciones = array },
        set_active_users(state,array){state.active_users= array },
        set_timesheet(state,array){ state.timesheet_data = array },
        set_timesheet_pros(state,array){ state.timesheet_data_pros = array },
        set_kanban(state,json){ state.kanban = json },

        //#innova#//

        set_ideas(state,array){ state.ideas = array },
        set_idea_actual(state,json){ state.idea_actual = json },
        
        set_ideas_reto(state,array){ state.ideas_reto = array },
        set_idea_actual_reto(state,json){ state.idea_actual_reto = json },

        set_retos(state,array){ state.retos = array },
        set_reto_actual(state,json){ state.reto_actual = json },
        set_coms_ideas(state,array){ state.coms_ideas = array },
        set_coms_retos(state,array){ state.coms_retos = array },
        set_coms_blogs(state,array){ state.coms_blogs = array },
        set_blogs(state,array){ state.blogs = array },
        set_categorias_retos(state,array){ state.categorias_retos = array },
        set_categorias_ideas(state,array){ state.categorias_ideas = array },

        set_puntos_value(state,array){state.puntos_value = array},
        set_puntos_user(state,json){state.puntos_user = json},
        set_idea_clicked(state,json){ state.idea_clicked = json },
        set_challenge_clicked(state,json){ state.challenge_clicked = json },
        set_paginado_retos(state,json){ state.paginado_retos = json },
        set_paginado_ideas(state,json){ state.paginado_ideas = json },
        set_paginado_ideas_retos(state,json){ state.paginado_ideas_retos = json },
        set_pagina_ideas(state,int){ state.pagina_actual_ideas = int },
        set_pagina_ideas_retos(state,int){ state.pagina_actual_retos = int },
        set_pagina_retos(state,int){ state.pagina_actual_retos = int },
        set_reto_actual_config(state,json){ state.reto_actual_config = json },
        set_idea_actual_config(state,json){ state.idea_actual_config = json },

        //regalos
        
        set_regalos_workarea(state,array){ state.regalos_workarea = array },
        set_redimidos_workarea(state,array){ state.redimidos_workarea = array },
        set_redimidos_lista(state,array){ state.redimidos_lista = array },

        //notificaciones innova

        set_notificaciones_eventos(state,array){ state.notificaciones_eventos = array },
        set_notificaciones_contador(state,int){ state.notificaciones_contador = int },

        set_user_data(state,json){ state.user_data = json }
    },

    actions: {

        //##    Generales    ##//

        // cuando se hace cambio de proyecto (workarea es la misma, cambia el proyecto)
        limpiar_area_proyecto(state){

            // limpieza de forecast
            this.commit('set_proyecto_actual',{'id':0,'creador_id':0})
            this.commit('set_personal',[])
            this.commit('set_horas',[])
            this.commit('set_horasip',{'valor':[]})
            this.commit('set_todas',[])
            this.commit('set_tareas',[])
            this.commit('set_temptarea',{'id':0})
            this.commit('set_temptarea_chat',{'id':0})
            this.commit('set_tareas_temp',[])
            this.commit('set_asignados',[])
            this.commit('set_asignadosp',[])
            this.commit('set_folders_pro',[])
            this.commit('set_proveedores',[])
            this.commit('set_compras',[])
            this.commit('set_master_tarea',[{'proyecto_id':0}])
            this.commit('set_master_compra',[{'proyecto_id':0}])
            this.commit('set_actual_rol','admin')
            this.commit('set_mensajes_pro',[])
            this.commit('set_archivos_pro',[])
            this.commit('set_notificaciones',[])
            this.commit('set_socket_pusher', 0 )
            this.commit('set_unread_mensajes_pro',[])
            this.commit('set_coordinador',{ proyectos: [], tareas:[], personal:[], compras:[], gantt:[], gantc:[], horas:[], balance:[] })
            this.commit('set_ingeniero',{ proyectos: [], tareas:[], personal:[], compras:[], gantt:[], gantc:[], horas:[], balance:[] })
            this.commit('set_cliente',{ proyectos: [], tareas:[], personal:[], compras:[], gantt:[], gantc:[], horas:[], balance:[] })
            this.commit('set_gestor',{ proyectos: [], tareas:[], personal:[], compras:[], gantt:[], gantc:[], horas:[], balance:[] })
            this.commit('set_colaborador',{ proyectos: [], tareas:[], personal:[], compras:[], gantt:[], gantc:[], horas:[], balance:[] })
            this.commit('set_timesheet_pros',[])
            this.commit('set_kanban',[])

            return this.state.proyecto_actual.id

        },

        async cerrar_sesion(state){

            this.commit('set_loading',true)

            await this.dispatch('limpiar_sesion')
            .then(response => {

                if(response == 0){

                    var nlocal ={
                      'run':true,
                      'tipo':'informativo', 
                      'titulo':'Sesión finalizada',
                      'contenido':'',
                      'errores':[],
                      'tiempo':6000,
                      'cerrar':false
                    }

                    this.commit('set_notificacion_local',nlocal)

                    setTimeout(() => {
                        
                        router.push({'name':'Inicio'})
                        this.commit('set_loading',false)
                    
                    },3000)

                }

                if(response >= 1){
                    window.location.reload()
                }

            })
            .catch(error => {
                console.log(error)
                window.location.reload()
            })
            .finally(()=>{/* router.push({ name: 'Dashboard'})*/ })

        },

        limpiar_sesion(state){

            // limpiar datos forecast

            this.commit('set_workarea_actual',{'id':0,'email':''})
            this.commit('set_workareas',[])
            this.commit('set_seccion_num',50)
            this.commit('set_seccion_head',1)
            this.commit('set_user',{'id':0})
            this.commit('set_token','')
            this.commit('set_proyectos',[])
            this.commit('set_todas',[])
            this.commit('set_compras',[])
            this.commit('set_tareas',[])
            this.commit('set_temptarea',{'id':0})
            this.commit('set_temptarea_chat',{'id':0})
            this.commit('set_tareas_temp',[])
            this.commit('set_user_horas',[])
            this.commit('set_personal',[])
            this.commit('set_proveedores',[])
            this.commit('set_proyecto_actual',{'id':0,'creador_id':0})
            this.commit('set_proyecto_actual_mishoras',{'id':0,'creador_id':0,'codigo':'Seleccione'})
            this.commit('set_proyecto_actual_horas',{'id':0,'creador_id':0,'codigo':'Select'})
            this.commit('set_tareas_horasp',[])
            this.commit('set_tareas_mishoras',[])
            this.commit('set_horas_mishoras',[])
            this.commit('set_horas_regisro_proyecto', [])
            this.commit('set_mensajes_pro',[])
            this.commit('set_folders_pro',[])
            this.commit('set_archivos_pro',[])
            this.commit('set_notificaciones',[])
            this.commit('set_socket_pusher', 0 )
            this.commit('set_unread_mensajes_pro',[])
            this.commit('set_coordinador',{ proyectos: [], tareas:[], personal:[], compras:[], gantt:[], gantc:[], horas:[], balance:[] })
            this.commit('set_ingeniero',{ proyectos: [], tareas:[], personal:[], compras:[], gantt:[], gantc:[], horas:[], balance:[] })
            this.commit('set_cliente',{ proyectos: [], tareas:[], personal:[], compras:[], gantt:[], gantc:[], horas:[], balance:[] })
            this.commit('set_gestor',{ proyectos: [], tareas:[], personal:[], compras:[], gantt:[], gantc:[], horas:[], balance:[] })
            this.commit('set_colaborador',{ proyectos: [], tareas:[], personal:[], compras:[], gantt:[], gantc:[], horas:[], balance:[] })
            this.commit('set_horas',[])
            this.commit('set_horasip',{'valor':[]})
            this.commit('set_asignados',[])
            this.commit('set_asignadosp',[])
            this.commit('set_master_tarea',[{'proyecto_id':0}])
            this.commit('set_master_compra',[{'proyecto_id':0}])
            this.commit('set_actual_rol','admin')
            this.commit('set_timesheet',[])
            this.commit('set_timesheet_pros',[])
            this.commit('set_kanban',[])

            //limpiar datos innova

            this.commit('set_ideas',[])
            this.commit('set_idea_actual',{'id':0,'l_descripcion':''})
            this.commit('set_ideas_reto',[])
            this.commit('set_idea_actual_reto',{'id':0,'l_descripcion':''})
            this.commit('set_retos',[])
            this.commit('set_reto_actual',{'id':0})
            this.commit('set_coms_ideas',[])
            this.commit('set_coms_retos',[])
            this.commit('set_coms_blogs',[])
            this.commit('set_blogs',[])
            this.commit('set_login',false)
            this.commit('set_idea_clicked',{'id':0})
            this.commit('set_challenge_clicked',{})
            this.commit('set_paginado_ideas', {'paginas':0,'actual':0,'total_ideas':0} )
            this.commit('set_paginado_ideas_retos', {'paginas':0,'actual':0,'total_ideas':0} )
            this.commit('set_paginado_retos', {'paginas':0,'actual':0,'total_ideas':0} )
            this.commit('set_pagina_ideas', 0 )
            this.commit('set_pagina_ideas_retos', 0 )
            this.commit('set_pagina_retos', 0 )
            this.commit('set_idea_actual_config',{'seccion':0})
            this.commit('set_reto_actual_config',{'seccion':0})
            
            // Regalos 
            this.commit('set_regalos_workarea',[] )
            this.commit('set_redimidos_workarea',[] )
            this.commit('set_redimidos_lista',[] )
            this.commit('set_notificaciones_contador',0)
            this.commit('set_notificaciones_eventos',[])
            this.commit('set_user_data',{'t_ideas':0,'t_retos':0,'t_puntos':0,'redimidos':0})
            this.commit('set_puntos_user',{"crear_idea":0,"crear_reto":0,"comt_idea":0,"comt_reto":0,"like_idea":0,"like_reto":0,"mejora_idea":0,"mejora_reto":0,"ver_idea":0,"ver_reto":0,"star_idea":0,"star_reto":0,"total_puntos":0})

            return this.state.proyecto_actual.id

        },

        async clean_workarea(){
            
            //limpiar datos forecast
            this.commit('set_workarea_actual',{'id':0,'email':''})
            this.commit('set_seccion_head',0)
            this.commit('set_proyectos',[])
            this.commit('set_todas',[])
            this.commit('set_compras',[])
            this.commit('set_tareas',[])
            this.commit('set_temptarea',{'id':0})
            this.commit('set_temptarea_chat',{'id':0})
            this.commit('set_tareas_temp',[])
            this.commit('set_user_horas',[])
            this.commit('set_personal',[])
            this.commit('set_proveedores',[])
            this.commit('set_proyecto_actual',{'id':0,'creador_id':0})
            this.commit('set_proyecto_actual_mishoras',{'id':0,'creador_id':0,'codigo':'Seleccione'})
            this.commit('set_proyecto_actual_horas',{'id':0,'creador_id':0,'codigo':'Select'})
            this.commit('set_tareas_horasp',[])
            this.commit('set_tareas_mishoras',[])
            this.commit('set_horas_mishoras',[])
            this.commit('set_horas_regisro_proyecto', [])
            this.commit('set_mensajes_pro',[])
            this.commit('set_folders_pro',[])
            this.commit('set_archivos_pro',[])
            this.commit('set_notificaciones',[])
            this.commit('set_socket_pusher', 0 )
            this.commit('set_unread_mensajes_pro',[])
            this.commit('set_coordinador',{ proyectos: [], tareas:[], personal:[], compras:[], gantt:[], gantc:[], horas:[], balance:[], workarea:[],anothers:[] })
            this.commit('set_ingeniero',{ proyectos: [], tareas:[], personal:[], compras:[], gantt:[], gantc:[], horas:[], balance:[], workarea:[],anothers:[] })
            this.commit('set_cliente',{ proyectos: [], tareas:[], personal:[], compras:[], gantt:[], gantc:[], horas:[], balance:[], workarea:[],anothers:[] })
            this.commit('set_gestor',{ proyectos: [], tareas:[], personal:[], compras:[], gantt:[], gantc:[], horas:[], balance:[], workarea:[],anothers:[]})
            this.commit('set_colaborador',{ proyectos: [], tareas:[], personal:[], compras:[], gantt:[], gantc:[], horas:[], balance:[], workarea:[],anothers:[] })
            this.commit('set_horas',[])
            this.commit('set_horasip',{'valor':[]})
            this.commit('set_asignados',[])
            this.commit('set_asignadosp',[])
            this.commit('set_master_tarea',[{'proyecto_id':0}])
            this.commit('set_master_compra',[{'proyecto_id':0}])
            this.commit('set_actual_rol','admin')
            this.commit('set_timesheet',[])
            this.commit('set_timesheet_pros',[])
            this.commit('set_kanban',[])

            //limpiar datos innova

            this.commit('set_ideas',[])
            this.commit('set_idea_actual',{'id':0})
            this.commit('set_retos',[])
            this.commit('set_reto_actual',{'id':0})
            this.commit('set_coms_ideas',[])
            this.commit('set_coms_retos',[])
            this.commit('set_coms_blogs',[])
            this.commit('set_blogs',[])
            this.commit('set_idea_clicked',{'id':0})
            this.commit('set_challenge_clicked',{})
            this.commit('set_paginado_ideas', {'paginas':0,'actual':0,'total_ideas':0} )
            this.commit('set_paginado_ideas_retos', {'paginas':0,'actual':0,'total_ideas':0} )
            this.commit('set_paginado_retos', {'paginas':0,'actual':0,'total_ideas':0} )
            this.commit('set_pagina_ideas', 0 )
            this.commit('set_pagina_ideas_retos', 0 )
            this.commit('set_pagina_retos', 0 )
            this.commit('set_idea_actual_config',{'seccion':0})
            this.commit('set_reto_actual_config',{'seccion':0})

            // Regalos 
            this.commit('set_regalos_workarea',[] )
            this.commit('set_redimidos_workarea',[] )
            this.commit('set_redimidos_lista',[] )
            this.commit('set_notificaciones_contador',0)
            this.commit('set_notificaciones_eventos',[])
            this.commit('set_user_data',{'t_ideas':0,'t_retos':0,'t_puntos':0,'redimidos':0})
            this.commit('set_puntos_user',{"crear_idea":0,"crear_reto":0,"comt_idea":0,"comt_reto":0,"like_idea":0,"like_reto":0,"mejora_idea":0,"mejora_reto":0,"ver_idea":0,"ver_reto":0,"star_idea":0,"star_reto":0,"total_puntos":0})

            return this.state.workarea_actual.id

        },

        clean_project(){
            
            //limpiar datos actual proyecto
            this.commit('set_todas',[])
            this.commit('set_compras',[])
            this.commit('set_tareas',[])
            this.commit('set_temptarea',{'id':0})
            this.commit('set_temptarea_chat',{'id':0})
            this.commit('set_tareas_temp',[])
            this.commit('set_user_horas',[])
            this.commit('set_proyecto_actual',{'id':0,'creador_id':0})
            this.commit('set_proyecto_actual_mishoras',{'id':0,'creador_id':0,'codigo':'Seleccione'})
            this.commit('set_proyecto_actual_horas',{'id':0,'creador_id':0,'codigo':'Select'})
            this.commit('set_tareas_horasp',[])
            this.commit('set_tareas_mishoras',[])
            this.commit('set_horas_mishoras',[])
            this.commit('set_horas_regisro_proyecto', [])
            this.commit('set_mensajes_pro',[])
            this.commit('set_folders_pro',[])
            this.commit('set_archivos_pro',[])
            this.commit('set_notificaciones',[])
            this.commit('set_socket_pusher',0)
            this.commit('set_unread_mensajes_pro',[])
            this.commit('set_horas',[])
            this.commit('set_horasip',{'valor':[]})
            this.commit('set_asignados',[])
            this.commit('set_asignadosp',[])
            this.commit('set_master_tarea',[{'proyecto_id':0}])
            this.commit('set_master_compra',[{'proyecto_id':0}])
            this.commit('set_timesheet',[])
            this.commit('set_timesheet_pros',[])
            this.commit('set_kanban',[])

            return this.state.proyecto_actual.id

        },

        limpiar_inicio(){
            
            this.commit('set_proyecto_actual_mishoras',{'id':0,'creador_id':0,'codigo':'Seleccione'})
            this.commit('set_proyecto_actual_horas',{'id':0,'creador_id':0,'codigo':'Select'})
            this.commit('set_tareas_horasp',[])
            this.commit('set_tareas_mishoras',[])
            this.commit('set_horas_mishoras',[])
            //this.commit('set_personal_horasp',[])
            this.commit('set_horas_regisro_proyecto',[])
            this.commit('set_timesheet',[])
            this.commit('set_timesheet_pros',[])
            this.commit('set_proveedores',[])
            this.commit('set_personal',[])
            
            return this.state.proyecto_actual_mishoras.id + this.state.proyecto_actual_horas.id
        },

        set_seccion(state,i){ this.commit('set_seccion_num',i) },

        //##  Tareas Pusher  &  Ayudantes  #//

        guardar_duplicar_proyecto(state,array){
            
            let proyectos =  this.state.proyectos
            
            if(!proyectos.some((p)=> p.id == array[0].id)){
                this.state.proyectos.push(array[0])
            }

        },

        guardar_mensaje_tarea(state,array){

            for(let ind = 0; ind < array.length; ind++){
                this.state.mensajes_pro.push(array[ind])
            }

        },

        guardar_mensaje_tarea_pusher(state,i){
 

            var tempmens =[]
            var mensn = i
            let mens = this.state.mensajes_pro

            var boolmen = false

            for(let index = 0; index < mens.length; index++){
                if(mens[index].id == mensn[0].id){ boolmen = true }else{ boolmen = boolmen }
            }

            if(!boolmen){

                let unre = this.state.unread_mensajes_pro
                var aunread = []

                for (let index = 0; index < mens.length; index++){
                    tempmens.push(mens[index])
                }

                for (let x = 0; x < unre.length; x++){
                    aunread.push(unre[x])
                }

                tempmens.push(mensn[0]);
                aunread.push({'id':0,'mensaje_id':mensn[0].id,'user_id':this.state.user.id,'proyecto_id':mensn[0].proyecto_id,'tarea_id':mensn[0].tarea_id,'leido':0})

                this.commit('set_mensajes_pro',tempmens)
                if(this.state.temporaltarea_chat.id != mensn[0].tarea_id){this.commit('set_unread_mensajes_pro',aunread)}

            }

        },

        guardar_archivo_pusher(state,i){

            var larchi =[]
            var archivo = i
            let archr = this.state.archivos_pro

            var boolmen = false

            for(let index = 0; index < archr.length; index++){
                if(archr[index].id == archivo[0].id){ boolmen = true }else{ boolmen = boolmen }
            }

            if(!boolmen){

                larchi.push(archivo[0])

                for (let index = 0; index < archr.length; index++){
                    larchi.push(archr[index])
                }

                this.commit('set_archivos_pro',larchi)
            
            }
        },

        guardar_nueva_compra_pusher(state,array){
 
            let compras =  this.state.compras
            
            if(!compras.some((c)=> c.id == array[0].id)){
                this.state.compras.push(array[0])
            }

            setTimeout(()=>{ this.commit('set_updatetask') },300)
            
        },

        guardar_nueva_tarea_pusher(state,array){
            
            let tareas =  this.state.tareas

            if(!tareas.some((t)=> t.id == array[0].id)){
                this.state.tareas.push(array[0])
            }

            setTimeout(()=>{ this.commit('set_updatetask') },300)

        },

        borrar_tarea_pusher(state,array){
            
            let tareas =  this.state.tareas
            var atareas =[]
            
            if(tareas.some((t)=> t.id == array[0].id)){

                if(this.state.temporaltarea_chat.id == array[0].id){
                    this.commit('set_temptarea_chat',{'id':0})
                }

                if(this.state.temporaltarea.id == array[0].id){
                    this.commit('set_temptarea',{'id':0})
                }

                for(let index = 0; index < tareas.length; index++){
                    if(tareas[index].id != array[0].id ){ if(tareas[index].parent != array[0].id){ atareas.push(tareas[index])}}
                }

                this.commit('set_tareas',atareas)

                setTimeout(()=>{ this.commit('set_updatetask') },300)
            }

        },

        borrar_compra_pusher(state,array){

            let compras =  this.state.compras
            var acompras =[]

            if(compras.some((c)=> c.id == array[0].id)){

                if(this.state.temporalcompra_chat.id == array[0].id){
                    this.commit('set_temptarea_chat',{'id':0})
                }

                if(this.state.temporalcompra.id == array[0].id){
                    this.commit('set_tempcompra',{'id':0})
                }

                for(let index = 0; index < compras.length; index++){
                    if(compras[index].id != array[0].id ){ if(compras[index].parent != array[0].id){ acompras.push(compras[index])}}
                }

                this.commit('set_compras',acompras)

                setTimeout(()=>{ this.commit('set_updatetask') },300)

            }

        },

        nueva_carpeta_pusher(state,array){

            let folders = this.state.folders_pro
            
            if(!folders.some((f)=> f.id == array[0].id)){
                this.state.folders_pro.unshift(array)
            }

        },

        nuevo_kanban_pusher(state,array){

            let kanbans = this.state.kanban

            if(!kanbans.some((k)=> k.id == array[0].id)){
                this.state.kanban.push(array[0])
            }

        },

        add_categorias_store(state,array){

            //categorias array=[]

            //{'id':0,'cat':1,'pred':1,'name':'Sustainability'},
            //{'id':0,'cat':2,'pred':1,'name':'Life & Health'},
            //{'id':0,'cat':3,'pred':1,'name':'Beauty & Fashion'},
            //{'id':0,'cat':4,'pred':1,'name':'Home'},
            //{'id':0,'cat':5,'pred':1,'name':'Science & Technology'},
            //{'id':0,'cat':6,'pred':1,'name':'Turism & Travel'},
            //{'id':0,'cat':7,'pred':1,'name':'Transport'},
            //{'id':0,'cat':8,'pred':1,'name':'Food'},
            //{'id':0,'cat':9,'pred':1,'name':'Pets'},

            var categ_retos = []
            var categ_ideas = []

            categ_retos = array.filter((cr)=>{ return(cr.recurso == 'reto') })
            categ_ideas = array.filter((ci)=>{ return(ci.recurso == 'idea') })

            categ_retos.push({'id':0,'cat':0,'pred':1,'name':'Standard','recurso':'reto'})
            categ_ideas.push({'id':0,'cat':0,'pred':1,'name':'Standard','recurso':'idea'})

            this.commit('set_categorias_retos',categ_retos)
            this.commit('set_categorias_ideas',categ_ideas)

        },

        //##    Notificaciones Locales Predefinidas Generales    #//

        realizado(){

            const nlocal ={
                'run':true,
                'tipo':'realizado',
                'titulo': this.state.user.email,
                'contenido':'Success!',
                'errores':[],
                'tiempo':5000,
                'cerrar':false
            }

            this.commit('set_loading',false)
            this.commit('set_miniloading',false)
            this.commit('set_notificacion_local',nlocal)

        },

        sin_permisos_noti(){

            const nlocal ={
                'run':true,
                'tipo':'advertencia',
                'titulo': this.state.user.email,
                'contenido': this.state.workarea_actual.organizacion+' dont allowed view this section!',
                'errores':[],
                'tiempo':6000,
                'cerrar':true
            }

            this.commit('set_loading',false)
            this.commit('set_miniloading',false)
            this.commit('set_notificacion_local',nlocal)

        },

        failrecap(){

            const nlocal ={
                'run':true,
                'tipo':'alerta', 
                'titulo':'La verificación recapcha no fue exitosa',
                'contenido':'Comuniquese con asistencia',
                'errores':[],
                'tiempo':6000,
                'cerrar':false
            }
            
            this.commit('set_notificacion_local',nlocal)
            this.commit('set_loading',false)
            this.commit('set_miniloading',false)
        },

        failgtoken(){

            const nlocal ={
                'run':true,
                'tipo':'alerta', 
                'titulo':'La verificación con Google no fue exitosa',
                'contenido':'.',
                'errores':[],
                'tiempo':6000,
                'cerrar':false
            }
            
            this.commit('set_notificacion_local',nlocal)
            this.commit('set_loading',false)
            this.commit('set_miniloading',false)
        },

        faildata(){

            const nlocal ={
                'run':true,
                'tipo':'alerta', 
                'titulo':'Campo vacio o incorrecto',
                'contenido':'',
                'errores':[],
                'tiempo':5000,
                'cerrar':false
            }
            
            this.commit('set_notificacion_local',nlocal)
            this.commit('set_loading',false)
            this.commit('set_miniloading',false)
            
        },

        syncpusher(state,project_id){

            //Pusher.logToConsole = true

            var pusher = new Pusher(this.state.pushersitekey,{ 'cluster': this.state.pushercluster})

            var channel = pusher.subscribe(this.state.pusherchannelpro + project_id)
            
            if(project_id==0){
                this.commit('suscripcion_pusher',false)
                pusher.disconnect()
            }

            channel.bind("pusher:subscription_succeeded", (members) => {
                
                this.commit('suscripcion_pusher',true)
                this.commit('set_socket_pusher', pusher.connection.socket_id )
            })

            channel.bind("pusher:subscription_error", (error) => {

                this.commit('suscripcion_pusher',false)      

                var { status } = error

                if (status == 408 || status == 503) {
                    var nlocal ={
                        'run':true,
                        'tipo':'alerta', 
                        'titulo':'La sincronización entre clientes ha fallado',
                        'contenido':'',
                        'errores':[],
                        'tiempo':5000,
                        'cerrar':false
                    }
                    
                    this.commit('set_notificacion_local',nlocal)
                }

            })
        
            channel.bind('tareachat',(data,metadata)=>{ this.dispatch('guardar_mensaje_tarea_pusher',[data]) })
            channel.bind('storeagent',(data,metadata)=>{ this.dispatch('guardar_archivo_pusher',[data]) })
            channel.bind('nueva_compra',(data,metadata)=>{ this.dispatch('guardar_nueva_compra_pusher',[data]) })
            channel.bind('nueva_tarea',(data,metadata)=>{ this.dispatch('guardar_nueva_tarea_pusher',[data]) })
            channel.bind('borrar_tarea',(data,metadata)=>{ this.dispatch('borrar_tarea_pusher',[data]) })
            channel.bind('borrar_compra',(data,metadata)=>{ this.dispatch('borrar_compra_pusher',[data]) })
            channel.bind('nueva_carpeta',(data,metadata)=>{ this.dispatch('nueva_carpeta_pusher',[data]) })
            channel.bind('nuevo_kanban',(data,metadata)=>{ this.dispatch('nuevo_kanban_pusher',[data]) })

        },

        add_comts_retos(state,array){

            let comts = this.state.coms_retos   
            var newc = [...array,...comts]
            this.state.coms_retos = newc

        },

        add_comts_ideas(state,array){
           
           let comts = this.state.coms_ideas   
           var newc = [...array,...comts]
           this.state.coms_ideas = newc

        },

        add_comts_blogs(state,array){

            let comts = this.state.coms_blogs   
            var newc = [...array,...comts]
            this.state.coms_blogs = newc

        },

        add_blogs(state,json){
            this.state.blogs.unshift(json)
        },

        add_proveedor(state,json){
            this.state.proveedores.push(json)
        }

    },

    modules: {

    },

    getters:{
        //sum_count(state){ return state.array.filter(todo => todo.done) }
    }

})
